import { render, staticRenderFns } from "./WorkIconUnfold.vue?vue&type=template&id=b892dbe8"
import script from "./WorkIconUnfold.vue?vue&type=script&lang=js"
export * from "./WorkIconUnfold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports